"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDistanceExtra = exports.calculateDistance = exports.calculateDistByUnit = exports.calculateDist = void 0;
const KILOMETERS_PER_MILE = 1.60934;
const FEET_PER_MILE = 5280;
const METERS_PER_KILOMETER = 1000;
const EARTHS_RADIUS_IN_MILES = 3956;
const EARTHS_RADIUS_IN_KILOMETERS = 6371;
const toRad = x => (x * Math.PI) / 180;
const calculateDist = (lat1, lon1, lat2, lon2, imperial = true) => {
    const R = 6371;
    const latRad1 = toRad(lat1);
    const latRad2 = toRad(lat2);
    const dLon = toRad(lon2 - lon1);
    const x = dLon * Math.cos((latRad1 + latRad2) / 2);
    const y = toRad(lat2 - lat1);
    const d = Math.sqrt(x * x + y * y) * R;
    if (imperial) {
        const dMiles = d / KILOMETERS_PER_MILE;
        if (dMiles * FEET_PER_MILE <= 750) {
            const dFt = Math.round((dMiles * FEET_PER_MILE) / 50) * 50;
            return { val: dFt.toString(), dType: 'ft' };
        }
        return { val: dMiles.toFixed(1), dType: 'mi' };
    }
    if (d > 1) {
        return { val: d.toFixed(1), dType: 'km' };
    }
    return { val: (d * METERS_PER_KILOMETER).toFixed(1), dType: 'm' };
};
exports.calculateDist = calculateDist;
function throwInvalidUnitError(unit) {
    throw new Error(`Invalid unit: ${unit}`);
}
const calculateDistByUnit = (lat1, lon1, lat2, lon2, unit = 'mi') => {
    const R = unit == 'mi' ? EARTHS_RADIUS_IN_MILES : EARTHS_RADIUS_IN_KILOMETERS;
    const latRad1 = toRad(lat1);
    const latRad2 = toRad(lat2);
    const dLon = toRad(lon2 - lon1);
    const x = dLon * Math.cos((latRad1 + latRad2) / 2);
    const y = toRad(lat2 - lat1);
    const d = Math.sqrt(x * x + y * y) * R;
    switch (unit) {
        case 'mi':
            return { val: d.toFixed(1), dType: 'mi' };
        case 'km':
            return { val: d.toFixed(1), dType: 'km' };
        case 'm':
            return { val: (d * METERS_PER_KILOMETER).toFixed(1), dType: 'm' };
        default:
            throwInvalidUnitError(unit);
    }
};
exports.calculateDistByUnit = calculateDistByUnit;
const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const distanceVal = exports.calculateDistByUnit(lat1, lon1, lat2, lon2, 'm');
    const distance = Number(distanceVal.val);
    return exports.getDistanceExtra(distance);
};
exports.calculateDistance = calculateDistance;
const getDistanceExtra = distance => {
    const miles = distance / 1609.34;
    const feet = distance * 3.28084;
    let newDistance = miles;
    let unit = 'mi';
    let distanceStr = newDistance.toFixed(1) + ' ' + unit;
    if (feet < 1000) {
        newDistance = feet;
        unit = 'ft';
        distanceStr = newDistance.toFixed(0) + ' ' + unit;
    }
    return {
        distance: newDistance,
        unit,
        distanceStr,
        distanceInMeters: distance,
        fixedDistance: feet < 1000 ? newDistance.toFixed(0) : newDistance.toFixed(1),
    };
};
exports.getDistanceExtra = getDistanceExtra;
